import N8nPagination from './Pagination.vue';

export default N8nPagination;
